import { type BaseButtonProps, Button, ButtonGroup } from "../button";
import { Icon } from "../icons";

/** Props Interface */
interface CalendarControlsProps {
	buttonProps?: BaseButtonProps;
	backButtonProps?: BaseButtonProps;
	forwardButtonProps?: BaseButtonProps;
	onBack: () => void;
	currentFormat?: string;
	onForward: () => void;
	isAttached?: boolean;
}

export function CalendarControls({
	buttonProps = {},
	backButtonProps = {},
	forwardButtonProps = {},
	onBack,
	onForward,
	isAttached,
}: CalendarControlsProps) {
	return (
		<ButtonGroup isAttached={isAttached}>
			<Button
				icon={<Icon name="ChevronLeft" />}
				onClick={onBack}
				{...buttonProps}
				{...backButtonProps}
			/>
			<Button
				icon={<Icon name="ChevronRight" />}
				onClick={onForward}
				{...buttonProps}
				{...forwardButtonProps}
			/>
		</ButtonGroup>
	);
}
